import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ContentBuilderVersion } from 'src/app/views/content/content-generator.service';

@Component({
  selector: 'app-version-tile',
  standalone: true,
  imports: [DatePipe, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatTooltipModule, TranslateModule],
  templateUrl: './version-tile.component.html',
  styleUrls: ['./version-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionTileComponent {
  version = input.required<ContentBuilderVersion>();
  isActive = input<boolean>(false);
  isInserting = input<boolean>(false);
  showInsertAction = input(true);
  showChatAction = input(false);

  restore = output<void>();
  delete = output<HTMLElement>();
  insert = output<HTMLElement>();
  chat = output<void>();

  onRestore() {
    this.restore.emit();
  }

  onDelete(event: Event) {
    event.stopPropagation();
    this.delete.emit(event.currentTarget as HTMLElement);
  }

  onInsert(event: Event) {
    event.stopPropagation();
    this.insert.emit(event.currentTarget as HTMLElement);
  }

  onChat(event: Event) {
    event.stopPropagation();
    this.chat.emit();
  }
}
